import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'db0053',
    ecrans: ['00-2'],
    params: ['id']
});
